import { FETCH_STORYBOARD, SAVE_STORYBOARD_SETTINGS } from "./actions";

const defaultState = {
    scenes: [],
    shotsByScene: {},
    loading: true,
    errors: null,
    settings: null
};

const reducer = (state = defaultState, action: any = {}) => {
    switch (action.type) {
        case FETCH_STORYBOARD + "_PENDING":
            return { ...state, loading: true, errors: null };

        case FETCH_STORYBOARD + "_FULFILLED":
            return {
                ...state,
                loading: false,
                scenes: action.payload.data.scenes,
                settings: action.payload.data.settings || null,
                errors: null
            };

        case SAVE_STORYBOARD_SETTINGS + "_PENDING":
            return { ...state };

        case SAVE_STORYBOARD_SETTINGS + "_FULFILLED":
            return { ...state, settings: action.payload.data.settings || state.settings };

        case FETCH_STORYBOARD + "_REJECTED":
            return { ...state, loading: false, errors: action.payload };

        default:
            return state;
    }
};

export default reducer;
